import { render, staticRenderFns } from "./Type3Form.vue?vue&type=template&id=2ecef61b&scoped=true&"
import script from "./Type3Form.vue?vue&type=script&lang=js&"
export * from "./Type3Form.vue?vue&type=script&lang=js&"
import style0 from "./Type3Form.vue?vue&type=style&index=0&id=2ecef61b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecef61b",
  null
  
)

export default component.exports